module.exports = __webpack_public_path__ + "static/media/arrow__new.43920365.svg";